import { REACT_APP_API_SF } from '../../config'
import axios from 'axios'

export async function getCftQuoteAvg(body) {
    try {
        const response = await axios.post(REACT_APP_API_SF + '/GetCftQuoteAvg', body)

        return response?.data?.data
    } catch (error) {
        console.log(getCftQuoteAvg, error)
        return error
    }
}
